// extracted by mini-css-extract-plugin
module.exports = {"SegmentedControl":"SegmentedControl_SegmentedControl__2pNlu","selected":"SegmentedControl_selected__2VGxh"};